/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { ManagedData, ManagementState } from 'store/modules/management_store/types';
import DataTable from 'react-data-table-component';
import ManagementTask from 'components/molecules/management_task';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import Loader from 'components/atoms/loader';
import ManagementFinishBidding from 'components/atoms/management_finish_bidding';
import ManagementRemoveBidding from 'components/atoms/management_remove_bidding';
import useRefetchOnModalMutation from 'hooks/useRefetchOnModalMutation';
import { datatableColumns, datatableData } from './datatable_list';
import { ContainerManagedList } from './styles';

interface ManagedListProps {
  managedList: Array<ManagedData>;
  toggleSelected?: (id: number, updateAll?: boolean) => void;
  selectedManageds: Array<number>;
  onTaskMutation?: () => void;
}

const ManagedList = (props: ManagedListProps) => {
  const {
    managedList,
    toggleSelected = () => {},
    selectedManageds,
    onTaskMutation = () => {},
  } = props;

  const [modalManagementTaskOpened, setModalManagementTaskOpened] = useState<boolean>(false);
  const [modalFinishBiddingOpened, setModalFinishBiddingOpened] = useState<boolean>(false);
  const [modalRemoveBiddingOpened, setModalRemoveBiddingOpened] = useState<boolean>(false);
  const [taskType, setTaskType] = useState<string>('');
  const [currentBiddingId, setCurrentBiddingId] = useState<number>(-1);
  const [currentBiddingTotalOpenedTasks, setcurrentBiddingTotalOpenedTasks] = useState<number>(0);

  const { request } = useSelector<ApplicationState, ManagementState>(
    (state) => state.session.management,
  );

  const customStyles = {
    headCells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    cells: {
      style: {
        paddingLeft: '10px',
        paddingRight: '10px',
      },
    },
    rows: {
      style: {
        fontSize: '14px',
      },
    },
  };

  useEffect(() => {
    if (modalManagementTaskOpened) return;
    setCurrentBiddingId(-1);
  }, [modalManagementTaskOpened]);

  useRefetchOnModalMutation(
    modalManagementTaskOpened,
    [request.create_tasks?.loaded, request.create_progress?.loaded],
    onTaskMutation,
  );

  useEffect(() => {
    if (modalFinishBiddingOpened) return;
    setCurrentBiddingId(-1);
  }, [modalFinishBiddingOpened]);

  useEffect(() => {
    if (modalRemoveBiddingOpened) return;
    setCurrentBiddingId(-1);
  }, [modalRemoveBiddingOpened]);

  return (
    <>
      {request.managed.loading && <Loader />}
      {request.managed.loaded && (
        <ContainerManagedList>
          <DataTable
            columns={datatableColumns(
              setModalManagementTaskOpened,
              setModalFinishBiddingOpened,
              setModalRemoveBiddingOpened,
              setTaskType,
              setCurrentBiddingId,
              setcurrentBiddingTotalOpenedTasks,
              toggleSelected,
            )}
            customStyles={customStyles}
            data={datatableData(managedList, selectedManageds)}
            noDataComponent={
              <div className="p-5 w-100 text-center">
                Você e a sua equipe não tem licitações sendo gerenciadas.
              </div>
            }
          />
        </ContainerManagedList>
      )}
      <ManagementTask
        modalManagementTaskOpened={modalManagementTaskOpened}
        setModalManagementTaskOpened={setModalManagementTaskOpened}
        bidding={{
          id: currentBiddingId,
          bidding_id: currentBiddingId.toString(),
          edital: managedList.find((bidding) => bidding.id === currentBiddingId)?.edital || '',
          public_body: managedList.find((bidding) => bidding.id === currentBiddingId)
            ?.public_body || { nome: '' },
          orgao_estado:
            managedList.find((bidding) => bidding.id === currentBiddingId)?.orgao_estado || '',
          orgao_cidade:
            managedList.find((bidding) => bidding.id === currentBiddingId)?.orgao_cidade || '',
        }}
        taskType={taskType}
      />
      <ManagementFinishBidding
        modalFinishBiddingOpened={modalFinishBiddingOpened}
        setModalFinishBiddingOpened={setModalFinishBiddingOpened}
        biddingId={currentBiddingId}
        totalOpenedTaks={currentBiddingTotalOpenedTasks}
      />
      <ManagementRemoveBidding
        modalRemoveBiddingOpened={modalRemoveBiddingOpened}
        setModalRemoveBiddingOpened={setModalRemoveBiddingOpened}
        biddingId={currentBiddingId}
        totalOpenedTaks={currentBiddingTotalOpenedTasks}
      />
    </>
  );
};

export default ManagedList;
